import { render, staticRenderFns } from "./PeopleReportScreen.vue?vue&type=template&id=ff425a4c"
import script from "./PeopleReportScreen.vue?vue&type=script&lang=js"
export * from "./PeopleReportScreen.vue?vue&type=script&lang=js"
import style0 from "./PeopleReportScreen.vue?vue&type=style&index=0&id=ff425a4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports